import r from "./_trimmedEndIndex.js";
var a = /^\s+/;
function t(e) {
  return e && e.slice(0, r(e) + 1).replace(a, "");
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseTrim.js
// module id = 1451
// module chunks = 41